import { Injectable } from '@angular/core';
import { CommonService } from 'src/app/shared/utils/common.service';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { uniformeModulo } from 'src/app/aplicaciones-modulos/spyral/diccionarios/uniformeModule';

@Injectable({
  providedIn: 'root'
})
export class ParametroInicialService {

  diccionarioUrl: any;
  urlUniforme: string;
  constructor(private commom: CommonService,
    private utilServices: UtilsService) {
    this.urlUniforme = this.utilServices.getUniforme();
    this.diccionarioUrl = uniformeModulo.url.uniforme;
  }

  getAllParametroInicial() {
    return this.commom.peticionGetConHeader(this.urlUniforme + this.diccionarioUrl.parametroIncial);
  } 

  createEditParametroInicial(parametro: any) {
    return this.commom.peticionPostConHeader(this.urlUniforme + this.diccionarioUrl.parametroIncial, parametro);
  } 

  deleteParametroInicial(parametro: string) {
    return this.commom.peticionDeleteConHeader(this.urlUniforme + this.diccionarioUrl.parametroIncial +'/'+ parametro);
  } 

}
